module.exports = __webpack_public_path__ + "img/img-zapier-background-image-new.5699af45.svg";